import React, { useContext, useState } from 'react';
import { MultiSelectionGroup, Card, MultiOptionProps } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import styles from '../Configurator.module.less';
import { IntegrationPageSectionT } from '../StateManagement/types';

type FundingConfiguratorPropT = {
  content: {
    options: MultiOptionProps[];
    title: string;
    subtitle: string;
  };
};

const FundingConfigurator = ({ content }: FundingConfiguratorPropT) => {
  const {
    SdkConfigurator: { batchUpdateSdkSettings }
  } = useContext(IntegrationPageSectionContext) as IntegrationPageSectionT;

  const [selection, setSelection] = useState(() => {
    if (content?.options) {
      return content?.options?.map((c) => ({ ...c, checked: true, name: c.label }));
    }
    return [];
  });

  const handleSelectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    const enableFunding: string[] = [];
    const disableFunding: string[] = [];
    const newSelection = selection.map((s) => {
      let selectionValue = s;
      if (s.value === value) {
        selectionValue = { ...s, value, checked };
      }
      if (selectionValue.checked) {
        enableFunding.push(selectionValue.value);
      } else {
        disableFunding.push(selectionValue.value);
      }
      return selectionValue;
    });
    setSelection(newSelection);
    batchUpdateSdkSettings({
      enableFunding: enableFunding.join(','),
      disableFunding: disableFunding.join(',')
    });
  };

  return (
    <div className={styles.card_container}>
      <Card>
        <div className={styles.card_header}>{content.title}</div>
        <Card.Content>{content.subtitle}</Card.Content>
        <MultiSelectionGroup
          hideLabel
          label={''}
          onChange={handleSelectionChange}
          options={selection}
          className={styles.multi_select}
        />
      </Card>
    </div>
  );
};

export default FundingConfigurator;
